import type { Partner } from "@/features/partners/types";
import { PublicEmpty } from "@/pages/public/PublicState";
import { PartnerCard } from "./PartnerCard";

interface PartnerGridProps {
  partners: Partner[];
}

export function PartnerGrid({ partners }: PartnerGridProps) {
  if (partners.length === 0) {
    return (
      <PublicEmpty
        title="No partners found"
        description="Active partners will appear here once they are published in the CMS."
      />
    );
  }

  return (
    <div className="grid min-w-0 gap-5 sm:grid-cols-2 xl:grid-cols-3">
      {partners.map((partner) => (
        <PartnerCard key={partner.id} partner={partner} />
      ))}
    </div>
  );
}
